import React from 'react';
import { st, classes } from '../../HamburgerOverlay.component.st.css';
import type { IHamburgerOverlayProps } from '../../../HamburgerOverlay.props';
import HamburgerOverlayCommon from '../../HamburgerOverlay';
import { useHamburgerMenuContext } from '../../../../HamburgerMenuContext';
import animationClasses from '../../HamburgerOverlayAnimation.scss';
import { formatClassNames } from '@wix/editor-elements-common-utils';
import semanticClassNames from '../../../HamburgerOverlay.semanticClassNames';

const DefaultSkin: React.FC<IHamburgerOverlayProps> = props => {
  const {
    containerRootClassName,
    showBackgroundOverlay,
    hasResponsiveLayout,
    isMenuContainerFullscreen,
    stylableClassName,
    customClassNames = [],
  } = props;

  const { isMenuOpen = false } = useHamburgerMenuContext();

  const shouldShowStylableBackground =
    (showBackgroundOverlay && hasResponsiveLayout) || isMenuContainerFullscreen;

  const rootClassName = st(
    containerRootClassName,
    {
      showBackgroundOverlay,
      isMenuOpen,
      shouldScroll: !hasResponsiveLayout,
    },
    classes.root,
    animationClasses.root,
  );

  const overlayClassName = st(
    classes.overlay,
    {},
    shouldShowStylableBackground ? stylableClassName : undefined,
    showBackgroundOverlay && hasResponsiveLayout
      ? formatClassNames(semanticClassNames.root, ...customClassNames)
      : undefined,
  );

  return (
    <HamburgerOverlayCommon
      {...props}
      rootClassName={rootClassName}
      overlayClassName={overlayClassName}
      scrollContentClassName={st(classes.scrollContent)}
    />
  );
};

export default DefaultSkin;
